var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"32px","font-family":"system-ui"}},[_c('h2',[_vm._v("Payment Success")]),_c('p',[_vm._v("Thanks! (Test mode)")])])}]

export { render, staticRenderFns }